import { DataLayerHandler } from 'Shared/GoogleTagManager/DataLayerHandler';
import { ToastsErrorBottomLeft } from 'Shared/Toast';

export function ShowResponseError(error: any) {
  const errors = [];
  const responseError = error.response;

  if (responseError === undefined || responseError.data === undefined) {
    errors.push('خطا در شبکه');
    console.error('error: ', error);
    DataLayerHandler.addError('خطا در شبکه', String(503));
  } else if (responseError.status === 401) {
    // todo // signIn();
  } else if (responseError.status === 403) {
    errors.push('شما مجوز دسترسی به این بخش را ندارید');
    DataLayerHandler.addError('شما مجوز دسترسی به این بخش را ندارید', String(403));
  } else if (responseError.status === 400 && responseError.data) {
    if (responseError.data instanceof Blob) {
      const errorText = responseError.data.text();
      errors.push(...JSON.parse(errorText));
    } else {
      errors.push(...responseError.data);
    }
    DataLayerHandler.addError(errors?.join(' ,'), String(400));
  } else {
    errors.push('خطا در عملیات');
    console.error('error: ', error);
    DataLayerHandler.addError('خطا در عملیات', String(500));
  }

  return <>{ToastsErrorBottomLeft(errors)}</>;
}
